<script setup lang="ts">
// Owned copy of shared-fe/components/ui/Badge.vue (scoped CSS).
withDefaults(defineProps<{ variant?: 'default' | 'secondary' | 'outline' | 'success' | 'danger' }>(), {
  variant: 'secondary',
})
</script>

<template>
  <span :class="['badge', variant]"><slot /></span>
</template>

<style scoped>
.badge {
  display: inline-flex;
  align-items: center;
  border-radius: 999px;
  border: 1px solid transparent;
  padding: 0.05rem 0.6rem;
  font-size: 0.75rem;
  font-weight: 500;
  white-space: nowrap;
}
.default {
  background: var(--accent);
  color: #fff;
}
.secondary {
  background: var(--border);
  color: var(--fg);
}
.outline {
  border-color: var(--border);
  color: var(--fg-muted);
}
.success {
  background: var(--gain);
  color: #fff;
}
.danger {
  background: var(--loss);
  color: #fff;
}
</style>
